import { ActivatedRouteSnapshot, RouterStateSnapshot, Router, UrlSegment } from '@angular/router';
import {Injectable, Injector} from '@angular/core';
import {ApiMessageService, MessageType} from '../core/api-message.service';
import {CommonService} from '../common/controller/common.service';

import {Observable} from 'rxjs';
import { switchMap, map } from 'rxjs/operators';
import { AuthService } from './auth.service';


@Injectable()
export class AuthGuard  {

  constructor(private router: Router,
              private authService: AuthService,
              protected injector: Injector,
              protected apiMessageService: ApiMessageService) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {

    const service: CommonService<any> = this.injector.get(route.data['service']);
    const pCheck = route.data['function'] ? route.data['function'] : 'pCheck';
    this.authService.redirectUrl = state.url;
    return service[pCheck]().pipe(map((result) => {
      if (result) {
        return true;
      }
      if (result != null) {
        this.router.navigate(['/']);
        this.apiMessageService.sendMessage(MessageType.ERROR, 'Permessi non sufficienti');
      } else {
        this.router.navigate(['auth/signin']);
      }
    }));
  }

}
